import { Stack, Typography } from '@mui/material';
import React from 'react';
import { Tooltip } from 'react-leaflet';

const MapLeafletGeofenceTooltip = (props) => {
  const { value, ...rest } = props;

  return (
    <Tooltip direction='top' className='leaflet-tooltip-top-geofence' {...rest}>
      <Stack
        direction='row'
        sx={(theme) => ({
          fontSize: '12px',
          bgcolor: 'background.paper',
          overflow: 'hidden',
          borderRadius: theme.shape.borderRadius,
        })}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          sx={(theme) => ({
            padding: '4px 6px',
            bgcolor: 'background.paper',
            color: theme.palette.common.black,
            '.MuiTypography-root': {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
              fontSize: '12px',
            },
          })}>
          <Typography variant='body1'>{value.short_name}</Typography>
        </Stack>
      </Stack>
    </Tooltip>
  );
};

export default MapLeafletGeofenceTooltip;
